import { Injectable } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { SessionStorageService } from '../../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../../environments/environment';
import { inject } from '@angular/core';
import{SpouseDetailModel} from '../spouse-detail-model/spouse-detail-model';




@Injectable({
  providedIn: 'root'
})
export class SpouseDetailService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async spouseDetails(spouseDetail: SpouseDetailModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savemnspousedetail;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: spouseDetail.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

   // GET SPOUSE DETAILS

   async getSpouseDetails(repCode:string) {

    const API_URL: string = environment.baseUrl + environment.apis.getmnpersonaldetail;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "pias_rep_code": repCode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
  
  }
  
  

